import React from "react";
import GenreContainer from "./GenreContainer";

const Explore = () => {
  return (
    <div>
      <h1 style={{ textAlign: "center", margin: "15px" }}>
        Explore All Genres
      </h1>
      <GenreContainer />
    </div>
  );
};

export default Explore;
